module.exports = __webpack_public_path__ + "img/decast-logo.c9b940fa.svg";